import {create} from 'zustand'

type State = {
  open: boolean
  toggle: () => void
  close: () => void
  openDrawer: () => void
}

export const usePolicyChatDrawerStore = create<State>((set) => ({
  open: false,
  toggle: () => set((state) => ({open: !state.open})),
  close: () => set({open: false}),
  openDrawer: () => set({open: true}),
}))
